var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('qrcode',{staticClass:"qr-code",attrs:{"value":_vm.value,"tag":"img","alt":_vm.$ls.Global_Alt_DocumentQRCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }